export default __webpack_public_path__ + "static/media/613.058efe32.png";